// ofpYakit.js — OFP METNİNDEN YAKIT + RAPORUN TÜRETİLEN YAKIT DEĞERLERİ (12 Eki 2026) — TEK KAYNAK
//
// Rapor PDF'i (`archive-flight/report-pdf.ts`) ve web yedek rapor görünümü (`FlightReport.js`) buradan okur (web FUEL
// ekranı 21 Eki 2026, K1 ile kalktı; `isolateActiveLeg` burada kullanılmaya devam eder). iPad ikizi: `FuelView.swift` (`OFPText.isolateActiveLeg`, `parseMinTO`, `remaining`).
// 🔑 Serkan (12 Eki 2026): rapor yakıt sırası + *"min T/O fuel yerine, min T/O fuel'e göre olan extra fuel versek daha
//    anlamlı olur mu, yeşil renkte"* · *"kalkış yapılabilecek min fuel planda var"*.

/** Çok bacaklı OFP'de aktif bacağın bloğu — her bacak "FMS IDENT=<id>" ile başlar. İşaret yoksa metnin tamamı. */
export function isolateActiveLeg(full, fmsIdent) {
  if (!full) return '';
  if (!fmsIdent) return full;
  const marker = `FMS IDENT=${fmsIdent}`;
  const startIdx = full.indexOf(marker);
  if (startIdx === -1) return full;
  const afterStart = full.slice(startIdx);
  const nextIdx = afterStart.slice(marker.length).indexOf('FMS IDENT=');
  if (nextIdx === -1) return afterStart;
  return afterStart.slice(0, marker.length + nextIdx);
}

/** OFP'deki "MIN T/O FUEL n" (aktif bacak, lb). Satır yoksa null — rapor için bileşen toplamı YEDEĞİ YOK (sayı uydurulmaz;
 *  ekranlardaki toplam yedeği yalnız uçuş öncesi uyarı içindir). */
export function ofpMinKalkisYakiti(rawText, fmsIdent) {
  const m = isolateActiveLeg(rawText || '', fmsIdent).match(/MIN\s+T\/O\s+FUEL\s+(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

const sayi = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = parseInt(String(v).replace(/,/g, ''), 10);
  return Number.isFinite(n) ? n : null;
};

/** Yakıt alınmadan önce depodaki yakıt = FOB − UPLIFT (lb); uplift yoksa FOB. iPad FUEL modülündeki `remaining` ile aynı.
 *  FOB yoksa null. */
export function yakitAlimOncesi(fob, upliftLb) {
  const f = sayi(fob);
  if (f === null) return null;
  return Math.max(0, f - (sayi(upliftLb) ?? 0));
}

/** Asgari kalkış yakıtının üstündeki yakıt = T/O FUEL − MIN T/O FUEL (lb); biri yoksa null. Eksi = asgarinin altında. */
export function asgariUstuYakit(toFuel, minTo) {
  const t = sayi(toFuel), m = sayi(minTo);
  return t === null || m === null ? null : t - m;
}
